import { loadController, fetchRoute } from 'utils/routes';
import { registerPickerListeners } from 'features/processors/pickers';
import routes from 'features/routes/calendars';

fetchRoute(routes).then((route) => {
  loadController(route);
});

document.addEventListener('DOMContentLoaded', () => {
  registerPickerListeners();
});
